import type { FirestoreCard } from '@creative-kit/shared';

export const normalizeCardDates = (cardData: FirestoreCard): FirestoreCard => {
  if (!cardData.dates || cardData.dates.length === 0) {
    return cardData;
  }

  const normalizedDates = cardData.dates.map((entry) => {
    const normalizeDate = (value?: Date) => {
      if (!value) return undefined;
      const raw = value as unknown as { toDate?: () => Date };
      if (value instanceof Date) return value;
      if (raw?.toDate) return raw.toDate();
      return new Date(value);
    };

    return {
      ...entry,
      startDate: normalizeDate(entry.startDate),
      endDate: normalizeDate(entry.endDate),
    };
  });

  return {
    ...cardData,
    dates: normalizedDates,
  };
};
